import { MigrationModalManager } from '@fiverr-private/pro_migration';

export default MigrationModalManager;
